

/// <reference path="DBDocument.ts" />

// Generated class SupplierInvoice_ManagedObject

class SupplierInvoice_ManagedObject extends DBDocument
{
}
